import React from 'react';
import {
  Pane,
  Card,
  SelectField,
  Switch,
  majorScale,
  Text,
} from 'evergreen-ui';

const DELIMITERS = [
  { label: 'Comma (,)', value: ',' },
  { label: 'Semicolon (;)', value: ';' },
  { label: 'Tab (\\t)', value: '\t' },
  { label: 'Pipe (|)', value: '|' },
];

const ENCODINGS = [
  { label: 'UTF-8', value: 'utf-8' },
  { label: 'UTF-16', value: 'utf-16' },
  { label: 'ASCII', value: 'ascii' },
  { label: 'ISO-8859-1', value: 'iso-8859-1' },
];

const DelimiterSelector = ({
  delimiter,
  encoding,
  hasHeader,
  onDelimiterChange,
  onEncodingChange,
  onHasHeaderChange,
}) => {
  return (
    <Card
      backgroundColor="white"
      elevation={0}
      border="default"
      padding={majorScale(2)}
    >
      <Pane display="flex" gap={majorScale(3)}>
        <SelectField
          label="Delimiter"
          value={delimiter}
          onChange={(e) => onDelimiterChange(e.target.value)}
          width={200}
        >
          {DELIMITERS.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </SelectField>

        <SelectField
          label="File Encoding"
          value={encoding}
          onChange={(e) => onEncodingChange(e.target.value)}
          width={200}
        >
          {ENCODINGS.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </SelectField>

        <Pane marginTop={24}>
          <Switch
            checked={hasHeader}
            onChange={(e) => onHasHeaderChange(e.target.checked)}
            marginRight={majorScale(1)}
          />
          <Text>File has header row</Text>
        </Pane>
      </Pane>
    </Card>
  );
};

export default DelimiterSelector;
